package ui.screens.section.weddinginfo

import CompassDivider
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Place
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import models.WeddingInfo
import models.getResepsi
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import ui.screens.editorial.openGoogleMaps
import ui.theme.ColorScheme
import ui.theme.txtColor
import ui.theme.white

@Composable
fun WeddingTitle(
    text: String,
    modifier: Modifier = Modifier,
) {
    if (text.isEmpty()) return

    Text(
        text = text,
        style = MaterialTheme.typography.displayLarge.copy(
            fontSize = 24.sp
        ),
        color = ColorScheme.primary,
        textAlign = TextAlign.Center,
        modifier = modifier.padding(bottom = 32.dp)
    )
}

@Composable
fun PullQuote1(
    bgImage: DrawableResource,
    pullQuote1Progress: Float,
    list: List<WeddingInfo> = getResepsi(),
) {
    val additionalSize = (list.size - 1) * 250
    val sizeHight = if (list.size < 2) {
        400.dp
    } else {
        (400 + additionalSize).dp
    }
    Box(
        Modifier
            .padding(start = 40.dp, end = 40.dp, bottom = 32.dp, top = 48.dp)
            .widthIn(max = 450.dp)
            .height(sizeHight)
    ) {
        val shape = RoundedCornerShape(topStartPercent = 100, topEndPercent = 100)

        // Background dengan border & efek tint
        Image(
            painterResource(bgImage),
            modifier = Modifier
                .fillMaxSize()
                .border(1.dp, ColorScheme.secondary, shape)
                .padding(8.dp)
                .alpha(0.44f)
                .clip(shape),
            contentDescription = null,
            contentScale = ContentScale.Crop,
            colorFilter = null
        )

        // Isi konten undangan
        Column(
            Modifier
                .fillMaxSize()
                .padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            list.forEachIndexed { index, item ->
                // Judul section (Akad Nikah / Resepsi / dst)
                TitleText(item.name)
                // Divider di bawah judul
                SimpleDivider()
                // Detail waktu & tempat
                BodyText(
                    text = item.date,
                    styleText = MaterialTheme.typography.titleSmall.copy(
                        fontWeight = FontWeight.SemiBold
                    )
                )
                BodyText(
                    text = "Pukul : ${item.time}",
                    styleText = MaterialTheme.typography.titleSmall.copy(
                        fontWeight = FontWeight.Normal
                    )
                )
                BodyText(
                    text = "Tempat : ${item.location}",
                    styleText = MaterialTheme.typography.titleSmall.copy(
                        fontWeight = FontWeight.Normal,
                        fontSize = 14.sp
                    )
                )
                // Tombol lokasi hanya jika ada link Google Maps
                item.mapLink?.let { link ->
                    IconButton(
                        onClick = { openGoogleMaps(link) },
                        modifier = Modifier
                            .padding(top = 16.dp, bottom = 0.dp)
                            .size(48.dp)
                            .background(white, RoundedCornerShape(100f))
                    ) {
                        Icon(
                            Icons.Rounded.Place,
                            contentDescription = "Buka lokasi ${item.name}"
                        )
                    }
                }
                // Ornamen pemisah antar section (kecuali terakhir)
                if (index != list.lastIndex) {
                    Spacer(modifier = Modifier.height(24.dp))
                    CompassDivider(
                        Modifier.padding(horizontal = 16.dp, vertical = 5.dp),
                        isExpanded = true
                    )
                    Spacer(modifier = Modifier.height(24.dp))
                }
            }
        }
    }
}

@Composable
private fun TitleText(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.titleMedium,
        fontWeight = FontWeight.Bold,
        color = txtColor,
        modifier = Modifier.padding(vertical = 8.dp)
    )
}

@Composable
private fun BodyText(
    text: String,
    styleText: TextStyle = MaterialTheme.typography.titleSmall,
) {
    Text(
        text = text,
        style = styleText,
        color = txtColor,
        textAlign = TextAlign.Center,
        modifier = Modifier.padding(vertical = 8.dp)
    )
}

@Composable
private fun SimpleDivider() {
    HorizontalDivider(
        color = txtColor,
        thickness = 1.dp,
        modifier = Modifier
            .padding(vertical = 8.dp)
            .width(200.dp)
    )
}